import { attr, belongsTo } from 'spraypaint';
import stringOrNullAttr from '../stringOrNullAttr';
import ApplicationRecord from './ApplicationRecord';

const Promotion = ApplicationRecord.extend({
  attrs: {
    archived: attr(),
    auto_generated_codes_count: attr({ type: Number }),
    auto_generated_codes_prefix: stringOrNullAttr(),
    banner_description: stringOrNullAttr(),
    channel: belongsTo({ type: 'vouchers-channels', persist: false }),
    credit_balance_amount: attr({ type: Number }),
    discount_amount: attr({ type: Number }),
    discount_percentage: attr({ type: Number }),
    discount_str: attr(),
    discount_type: stringOrNullAttr(),
    valid_until: attr(),
    internal_description: stringOrNullAttr(),
    landing_page_url: stringOrNullAttr(),
    manual_code: stringOrNullAttr(),
    maximum_discounts_count_per_code: attr({ type: Number }),
    maximum_redemptions_count_per_code: attr({ type: Number }),
    meal_discount: attr({ type: Number }),
    minimum_meal_count_per_delivery: attr({ type: Number }),
    minimum_order_value: attr({ type: Number }),
    name: stringOrNullAttr(),
    promotion_type: stringOrNullAttr(),
    redemptions_count: attr({ persist: false }),
    redemption_duration_days: attr({ type: Number }),
    state: stringOrNullAttr(),
  },
  static: {
    endpoint: '/promotions',
    jsonapiType: 'vouchers-promotions',
  },
});

// Because the HTML date input gives us an empty string if it's cleared, we need
// to convert this to null because Graphiti does not type cast this correctly
// to nil for a Date type.
Promotion.attributeList.valid_until.setter = function (context, val) {
  const privateContext = context;
  // eslint-disable-next-line no-underscore-dangle
  privateContext._attributes[this.name] = val === '' ? null : val;
};

export default Promotion;
